import React from 'react';
export function Hero() {
  return <section className="bg-bg py-16 md:py-24 overflow-hidden" data-id="element-95">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-12" data-id="element-96">
        <div className="w-full md:w-[55%] space-y-8" data-id="element-97">
          <div className="inline-flex items-center gap-2 bg-accent/20 text-secondary px-4 py-1.5 rounded-full text-sm font-bold" data-id="element-98">
            <span data-id="element-99">🌙</span>
            NUEVO — Método basado en ciencia
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-text leading-tight" data-id="element-100">
            ¿Y si esta noche
            <br data-id="element-101" />
            pudieras dormir
            <br data-id="element-102" />
            de verdad por
            <br data-id="element-103" />
            primera vez?
          </h1>

          <p className="text-gray text-lg md:text-xl leading-relaxed max-w-lg" data-id="element-104">
            El Código del Sueño Profundo es el método de 14 días que regula tu
            ritmo circadiano, baja el cortisol nocturno y te devuelve el sueño
            profundo que mereces — sin pastillas, sin apps y sin contar ovejas.
          </p>

          <a href="#pricing" className="inline-block w-full sm:w-auto text-center bg-primary text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-105">
            QUIERO DORMIR MEJOR ESTA NOCHE &rarr;
          </a>

          <div className="flex flex-wrap items-center gap-6 text-sm font-bold text-text/80 pt-2" data-id="element-106">
            <div className="flex items-center gap-2" data-id="element-107">
              <span className="text-lg" data-id="element-108">🌙</span> Sin pastillas
            </div>
            <div className="flex items-center gap-2" data-id="element-109">
              <span className="text-lg" data-id="element-110">📥</span> Descarga inmediata
            </div>
            <div className="flex items-center gap-2" data-id="element-111">
              <span className="text-lg" data-id="element-112">⭐</span> Resultados en 14 días
            </div>
          </div>
        </div>

        <div className="w-full md:w-[45%] relative" data-id="element-113">
          <div className="absolute inset-0 bg-accent/20 rounded-full blur-3xl -z-10 transform translate-x-8 translate-y-8" data-id="element-114"></div>
          <img src="https://cdn.magicpatterns.com/uploads/e7VBU68xtx9tEAucvqe28P/Portada_Codigo_del_Sueno_Profundo.png" alt="El Código del Sueño Profundo" className="w-full aspect-square object-cover rounded-2xl shadow-2xl" data-id="element-115" />
        </div>
      </div>
    </section>;
}